import http from "@/api/services/http.service";
import { keysLower } from "@/core/helpers";

const guid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
    .replace(/[xy]/g, (c) => {
      let r = (Math.random() * 16) | 0;
      let v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
    .toUpperCase();
};

export default {
  GET_TOKEN({ commit }, form) {
    return http
      .post("/auth/login/operator", {
        login: form.login,
        password: form.password,
        operator_short_name: form.operator_short_name,
        id_device: guid(),
        id_platform: 3,
      })
      .then((response) => keysLower(response.data))
      .then((data) => {
        commit("SET_TOKEN", data.token);
      });
  },
  GET_TOKEN_FROM_ADMIN({ commit }, { token, id_operator }) {
    return http
      .post("/auth/login/token", { id_operator }, { headers: { token } })
      .then((resp) => keysLower(resp.data))
      .then((data) => {
        commit("SET_TOKEN", data.token);
        return data;
      });
  },
  REFRESH_TOKEN({ commit }) {
    return http
      .get("/auth/refresh/token")
      .then((response) => keysLower(response.data))
      .then((data) => {
        commit("SET_TOKEN", data.new_token);
      });
  },
};
